export const MESSAGE_CODE = {
  "SUCCESS": "SUCCESS",
  "UNKNOWN": "UNKNOWN",

  // AUTH
  "USER_NOT_EXIST": "USER_NOT_EXIST",
  "WRONG_PASSWORD": "WRONG_PASSWORD",
  "USER_VERIFY": "USER_VERIFY",
  "USER_LOCKED": "USER_LOCKED",

  // CSRF
  "NEED_CSRF": "NEED_CSRF"
}
